import React, { useState, useRef, useContext, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Select, MenuItem,
  InputLabel, FormControl, Paper, Stack, styled
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useJsApiLoader, GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import SearchBar from './FormsSearchBar';
import FormsBottomNavbar from './FormsBottomNavbar';
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios';
import { IconButton, InputAdornment } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { AuthContext } from './../../AuthContext/AuthContext';
import { BASE_URL } from './../../Api/ApiUrls';
import { checkPropertyUploadPermission } from "./subscriptionCheck";
import SubscriptionModal from "./SubscriptionModal";
import { GOOGLEMAPS_API_KEY } from './../../Api/ApiUrls';
import GuestLoginModal from '../../GuestLoginModal';
import { CircularProgress } from '@mui/material';
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
import FullScreenLoader from '../../FullScreenLoader';

const GOOGLE_MAPS_API_KEY = GOOGLEMAPS_API_KEY; 

const containerStyle = {
  width: '100%',
  height: '300px',
};

const centerDefault = {
  lat: 18.387449,
  lng: 78.803236,
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const RedButton = styled(Button)({
  backgroundColor: 'red',
  color: 'white',
  '&:hover': { backgroundColor: '#cc0000' },
});

const GreenButton = styled(Button)({
  backgroundColor: 'green',
  color: 'white',
  '&:hover': { backgroundColor: '#008000' },
});



const fieldMap = { 
  'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
  'Plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
  'Land': ['Site Area', 'Facing', 'Price', 'Road Width'],
  'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
  'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
  'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
  'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
  'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
  'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
  'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
  'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
  // 'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
};

const facingOptions = ['East', 'West', 'North', 'South', 'North-East', 'North-West', 'South-East', 'South-West'];

const yesNoOptions = ['Yes', 'No'];

const SellYourProperty = () => {
  const [workPhotos, setWorkPhotos] = useState([]);
         const { userId, isGuest } = useContext(AuthContext);
      const [showGuestModal, setShowGuestModal] = useState(false);
  const [apiHitCount, setApiHitCount] = useState(0);
  const [usingCurrentLocation, setUsingCurrentLocation] = useState(false);
  const [postedBy, setPostedBy] = useState('');
  const [uploadStatus, setUploadStatus] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
 const mapRef = useRef(null); 
  const [postedByOptions, setPostedByOptions] = useState([]);
const [uploadLimits, setUploadLimits] = useState(null);
const [locationConfirmed, setLocationConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");




const [subscriptionModal, setSubscriptionModal] = useState({
  open: false,
  type: null, // "NO_SUBSCRIPTION" | "LIMIT_EXCEEDED"
});

 useEffect(() => {
    if (isGuest) {
      setShowGuestModal(true);
    }
  }, [isGuest]);

useEffect(() => {
  const checkPermission = async () => {
    const result = await checkPropertyUploadPermission(userId);

  if (!result.allowed) {
      setSubscriptionModal({
        open: true,
        type: result.message?.toLowerCase().includes("subscription")
          ? "NO_SUBSCRIPTION"
          : "LIMIT_EXCEEDED",
      });
      return;
    }


    setUploadLimits(result.availability);

    const options = [];

    if (result.availability.Agent?.allowed) {
      options.push("Agent");
    }

    if (result.availability["Individual Owner/Builder"]?.allowed) {
      options.push("Owner", "Builder");
    }

    if (options.length === 0) {
      setSubscriptionModal({
        open: true,
        type: "LIMIT_EXCEEDED",
      });
      return;
    }

    setPostedByOptions(options);
  };

  if (userId) checkPermission();
}, [userId]);


  const generateNumberOptions = (max = 50) => {
    const options = [];
    for (let i = 0; i <= max; i++) {
      options.push(i);
    }
    return options;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "posted_by") {
      setPostedBy(value);  // For posted_by field
      setFormData((prevData) => ({
        ...prevData,
        posted_by: value,  // Update formData for posted_by
      }));
    } else if (name === "description") {
      // Handle description field
      setFormData((prevData) => ({
        ...prevData,
        description: value,  // Update formData for description
      }));
      setFormValues((prev) => ({
        ...prev,
        description: value,  // Update formValues for real-time change
      }));
    } else {
      // Generic handling for other fields
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getUserTypeFromPostedBy = (postedBy) => {
  if (postedBy === 'Agent') return 'Agent';
  if (postedBy === 'Owner' || postedBy === 'Builder') {
    return 'Individual Owner/Builder';
  }
  return null;
};


  const handleWorkPhotosChange = (e) => {
  if (e.target.files) {
    const files = Array.from(e.target.files);

    if (files.length > 4) {
      alert("❌ You can upload maximum 4 images only");
      return;
    }

    setWorkPhotos(files);
  }
};

  const [formData, setFormData] = useState({
    user_id: userId,
    category_id: '',
    type: 'sell',
    mobile_no: '',
    facing: '',
    roadwidth: '',
    site_area: '',
    buildup_area: '',
    posted_by: '',
    price: '',
    borewell: '',
    location: '',
    lat: '',
    long: '',
    units: 'ft', // Add this line
    nearby: 'Gandi Hospital',
    length: '',
    width: '',
    no_of_flores: '',
    _1bhk_count: '',
    _2bhk_count: '',
    _3bhk_count: '',
    _4bhk_count: '',
    bedrooms_count: '',
    bathrooms_count: '4',
    balcony: '',
    gated_security: 'yes',
    parking: '',
    advance_payment: '',
    duplex_bedrooms: '',
    power_backup: 'yes',
    rooms_count: '',
    shop_count: '',
    house_count: '',
    property_name: '',
    lift: '',
    description: '',
    // max_acres: '', 
  });

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });
  const [markerIcon, setMarkerIcon] = useState(null);

  useEffect(() => {
    if (isLoaded && window.google) {
      setMarkerIcon({
        url: "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23ff0000%22%20d%3D%22M12%202C8.13%202%205%205.13%205%209c0%205.25%207%2013%207%2013s7-7.75%207-13c0-3.87-3.13-7-7-7zm0%209.5c-1.38%200-2.5-1.12-2.5-2.5s1.12-2.5%202.5-2.5%202.5%201.12%202.5%202.5-1.12%202.5-2.5%202.5z%22%2F%3E%3C%2Fsvg%3E",
        scaledSize: new window.google.maps.Size(40, 40),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(20, 40)
      });
    }
  }, [isLoaded]);

  const [location, setLocation] = useState(centerDefault);
  const [address, setAddress] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [formValues, setFormValues] = useState({});
  const autocompleteRef = useRef(null);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

useEffect(() => {
  const fetchMobileNo = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users/${userId}/`);
      const user = response.data; // ✅ single user object

      console.log("Fetched user:", user);

      if (user?.mobile_no) {
        setFormData(prevData => ({
          ...prevData,
          mobile_no: user.mobile_no,
        }));
      } else {
        console.warn("Mobile number not found for user:", userId);
      }
    } catch (error) {
      console.error("Error fetching mobile_no:", error);
    }
  };

  if (userId) {
    fetchMobileNo();
  }
}, [userId]);



  // Track API hits
  const incrementApiHit = () => {
    setApiHitCount(prev => prev + 1);
    console.log(`Google Maps API hits: ${apiHitCount + 1}`);
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      setUsingCurrentLocation(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setLocation(pos);

          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${GOOGLE_MAPS_API_KEY}`
            );
            const data = await response.json();

            if (data.status == 'OK' && data.results.length > 0) {
              const address = data.results[0].formatted_address;
              setAddress(address);
            } else {
              console.warn('No address found, fallback to coordinates.');
              setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
            }
          } catch (error) {
            console.error('Google Maps API error:', error);
            setAddress(`Lat: ${pos.lat.toFixed(6)}, Lng: ${pos.lng.toFixed(6)}`);
          }
        },
        (error) => {
          console.error("Error getting current location:", error);
          alert("Error getting current location. Please enable location services.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };
  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place && place.geometry) {
        incrementApiHit();
        setUsingCurrentLocation(false);
        const newLoc = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setLocation(newLoc);
        setAddress(place.formatted_address);
      }
    }
  };

  const geocodeAddress = async () => {
    if (!address) return;

    if (usingCurrentLocation) {
      // Don't use API if we're using current location
      return;
    }

    if (window.google && window.google.maps) {
      incrementApiHit(); // This uses Google Maps API
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status == 'OK' && results[0]) {
          const location = results[0].geometry.location;
          setLocation({
            lat: location.lat(),
            lng: location.lng(),
          });
          setAddress(results[0].formatted_address);
        } else {
          //alert('Address could not be located. Please check input.');
        }
      });
    }
  };

  const labelKeyMap = {
    'Site Area': 'site_area',
    'Facing': 'facing',
    'Price': 'price',
    'No.of Floors': 'no_of_flores',
    'Buildup Area': 'buildup_area',
    'Borewell': 'borewell',
    'Lift': 'lift',
    'No.of Cars Parking': 'parking',
    '1bhk Count': '_1bhk_count',
    '2bhk Count': '_2bhk_count',
    '3bhk Count': '_3bhk_count',
    'Duplex Bedrooms': 'duplex_bedrooms',
    'Floors': 'no_of_flores',
    'Rooms Count': 'rooms_count',
    // 'Bedrooms-count': 'bedrooms_count',
    'No.of Bedrooms': 'bedrooms_count',
    'Shop Count': 'shop_count',
    'House Count': 'house_count',
    '1bhk': '_1bhk_count',
    '2bhk': '_2bhk_count',
    '3bhk': '_3bhk_count',
    '4bhk Count': '_4bhk_count',
    'Road Width': 'roadwidth',
    'Length': 'length',
    'Width': 'width',
    'Property Name': 'property_name'
  };

  const getBuildupAreaLabel = () => {
    const unit = formData.units || 'ft';
    const unitMap = {
      ft: 'Buildup Area (sqft)',
      m: 'Buildup Area (sqm)',
      cm: 'Buildup Area (sqcm)',
      in: 'Buildup Area (sqin)'
    };
    return unitMap[unit] || 'Buildup Area';
  };

  const handleBackClick = () => navigate(-1);
  const isNumericField = (label) => {
    const numericFields = [
      'Price',
      'Road Width',
      'Buildup Area',
      'Site Area',
      'Length',
      'Width',
      // Add other numeric fields
    ];
    return numericFields.includes(label);
  };

  const isValidNumber = (value) => {
    return value === '' || /^[0-9]*\.?[0-9]*$/.test(value);
  };

  const handleFieldChange = (label, value) => {
    const key = labelKeyMap[label] || label;

    if (isNumericField(label) && !isValidNumber(value)) {
      return; // Block invalid input
    }
    if (label === 'Site Area') {
  setFormData(prev => ({ ...prev, site_area: value }));
}

    // Update both formValues and formData
    setFormValues(prev => ({ ...prev, [label]: value }));

    // Special case: Length/Width are in formData
    if (label === 'Length' || label === 'Width') {
      setFormData(prev => ({ ...prev, [label.toLowerCase()]: value }));
    } else {
      setFormData(prev => ({ ...prev, [key]: value }));
    }
  };

  const handleMapClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setLocation({ lat, lng });
    setUsingCurrentLocation(false);
    incrementApiHit();

    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status == 'OK' && results[0]) {
          setAddress(results[0].formatted_address);
        } else {
          setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
        }
      });
    }
  };

  useEffect(() => {
    axios.get(`${BASE_URL}/property-category/`)
      .then(response => {
        const rentCategories = response.data.filter(
          cat => cat.category_type.toLowerCase() == 'sell'
        );
        const customOrder = [
          "Plot", "Land", "Commercial land/plot", "Rent with duplex building", "Duplex house", "Rental building",
          "Pg-offices", "Flat", "Villa", "Commercial building",
          "Apartment"
        ];

        // Sort rentCategories according to customOrder
        const sortedCategories = rentCategories.sort((a, b) => {
          return customOrder.indexOf(a.category) - customOrder.indexOf(b.category);
        });
        setCategories(sortedCategories);
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const groupedCategories = categories.reduce((acc, curr) => {
    const type = curr.category_type;
    if (!acc[type]) acc[type] = [];
    acc[type].push(curr);
    return acc;
  }, {});

  const handleSubmit = async (e) => {
  e.preventDefault();

       if (workPhotos.length > 4) {
  alert("❌ You can upload maximum 4 images only");
  return;
}

   if (!postedBy) {
    alert("Please select Posted By");
    return;
  }
   setLoading(true); // ✅ START LOADING

  if (!uploadLimits) {
    setSubscriptionModal({
      open: true,
      type: "NO_SUBSCRIPTION",
    });
    return;
  }

  const roleKey =
    postedBy === "Agent" ? "Agent" : "Individual Owner/Builder";

  if (!uploadLimits[roleKey]?.allowed) {
    setSubscriptionModal({
      open: true,
      type: "LIMIT_EXCEEDED",
    });
    return;
  }
    // ✅ success message

    // ✅ show all limits clearly in console
    console.log("📊 Subscription Limits:");

    console.log('Form submission initiated');
    console.log('Current formData:', JSON.stringify(formData, null, 2));
    console.log('Location:', location);
    console.log('Address:', address);
    console.log('Work photos count:', workPhotos.length);

    // Calculate site area in original units
    // const length = parseFloat(formData.length) || 0;
    // const width = parseFloat(formData.width) || 0;
    // const site_area = length * width;
let site_area = 0;

if (selectedCategory === 'Land') {
  // ✅ Use manually entered value for Land
  site_area = parseFloat(formData.site_area) || 0;

} else if (selectedCategory === 'Flat') {
  // ✅ Flat usually doesn't need site area calculation (keep existing)
  site_area = parseFloat(formData.site_area) || 0;

} else {
  // ✅ For Plot, Villa, etc → calculate
  const length = parseFloat(formData.length) || 0;
  const width = parseFloat(formData.width) || 0;
  site_area = length * width;
}

const updatedFormData = {
  ...formData,
  lat: location.lat.toString(),
  long: location.lng.toString(),
  location: address,
  site_area: site_area.toString(),
  description: formData.description,
};

    console.log('Data being prepared for submission:', updatedFormData);

    const formDataToSend = new FormData();

    // Log each form data entry
    Object.entries(updatedFormData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
      console.log(`Appended to formData: ${key} =`, value);
    });

    // Log each file being uploaded
    workPhotos.forEach((file, index) => {
      formDataToSend.append('new_property_images', file);
      console.log(`Appended file ${index + 1}:`, file.name, file.type, `${(file.size / 1024).toFixed(2)}KB`);
    });

    console.log('FormData prepared, sending to server...');

    try {
      console.log('Making POST request to:', `${BASE_URL}/property/`);

      const response = await axios.post(`${BASE_URL}/property/`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Server response:', response);

      if (response.status == 201 || response.status == 200) {
        console.log('Success! Response data:', response.data);
        setAlertMessage('Property submitted successfully!');
            setShowSuccess(true);
        // navigate('/dashboard');
      } else {
        console.warn('Unexpected status code:', response.status);
        setAlertMessage('Something went wrong. Try again.');
          setShowFailure(true);
      }
    } catch (error) {
      console.error('Submission Error:', error);

      if (error.response) {
        console.error('Error response data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);

        setAlertMessage(`Error: ${error.response.data.message || 'Something went wrong'}`);
      } else if (error.request) {
        console.error('No response received:', error.request);
        setAlertMessage('No response from server. Please check your connection.');
      } else {
        console.error('Request setup error:', error.message);
        setAlertMessage('An error occurred while submitting. Please try again.');
      }
        setShowFailure(true);
    } finally {
       setLoading(false); 
      console.log('Submission process completed');
    }
  };

  if (!isLoaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>Loading Google Maps...</Typography>
      </Box>
    );
  }

  const fields = selectedCategory && fieldMap[selectedCategory] ? fieldMap[selectedCategory] : [];

  return (
    <>
            <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: "#fff",
        boxShadow: 1,
      }}
    >
      <SearchBar onBackClick={handleBackClick} />
      </Box>
   
                         <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: '100vh',
                pt: { xs: '60px', sm: '100px' },  // matches header height
                  backgroundColor: 'rgb(239, 231, 221)',
                }}
              >
          <Box
            sx={{
              flexGrow: 1,
              p: { xs: 2, sm: 3 },
              pb: 10,
              display: 'flex',
              justifyContent: 'center', // center horizontally
            }}
          >

            <Paper
              elevation={2}
              sx={{
                p: { xs: 2, sm: 3 },
                mb: 3,
                width: '100%',
                boxSizing: 'border-box',
              }}
              component="form"
              onSubmit={handleSubmit}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}
              >
                Sell Your Property
              </Typography>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="category-label">Select Property Type</InputLabel>
                <Select
                  labelId="category-label"
                  value={selectedCategory}
                  required
                  onChange={(e) => {
                    const selected = categories.find(cat => cat.category == e.target.value);
                    setSelectedCategory(selected.category);
                    setFormData(prev => ({
                      ...prev,
                      category_id: selected.category_id,
                      type: selected.category_type,
                    }));
                  }}
                  label="Select Category"
                >
                  {Object.entries(groupedCategories).map(([type, items]) => [
                    ...items.map(cat => (
                      <MenuItem key={cat.category_id} value={cat.category}>
                        {cat.category}
                      </MenuItem>
                    ))
                  ])}
                </Select>
              </FormControl>

              {/* {fields.includes('Site Area') && selectedCategory !== 'Land' && ( */}
              {fields.includes('Site Area') && selectedCategory !== 'Land' && selectedCategory !== 'Flat' && (
                <Box key="Site Area" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Site Dimensions
                  </Typography>
                  <Stack direction="row" spacing={2}>
                    <TextField
                      fullWidth
                      label="Length"
                      variant="outlined"
                      value={formData.length || ''}
                      onChange={(e) => handleFieldChange('Length', e.target.value)}
                      required
                    />
                    <TextField
                      fullWidth
                      label="Width"
                      variant="outlined"
                      value={formData.width || ''}
                      onChange={(e) => handleFieldChange('Width', e.target.value)}
                      required
                    />
                    <TextField
                      select
                      label="Units"
                      defaultValue="ft"
                      sx={{ minWidth: 100 }}
                      value={formData.units || 'ft'}
                      onChange={(e) => setFormData(prev => ({ ...prev, units: e.target.value }))}
                    >
                      {['ft', 'm', 'cm', 'in'].map((unit) => (
                        <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                      ))}
                    </TextField>
                  </Stack>
                </Box>
              )}
              {fields.includes('Site Area') && selectedCategory === 'Flat' && (
  <Box key="Flat Area" sx={{ mb: 2 }}>
    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
      Area
    </Typography>

    <Stack direction="row" spacing={2}>
 <TextField
  fullWidth
  label={selectedCategory === 'Flat' ? 'Floor Area' : 'Area'}
  variant="outlined"
  value={formData.site_area || ''}
  onChange={(e) => handleFieldChange('Site Area', e.target.value)}
  required
/>
      <TextField
        select
        label="Units"
        sx={{ minWidth: 120 }}
        value={formData.units || 'ft'}
        onChange={(e) =>
          setFormData((prev) => ({ ...prev, units: e.target.value }))
        }
      >
        {['sq.ft', 'sq.m', 'sq.yd', 'acre'].map((unit) => (
          <MenuItem key={unit} value={unit}>
            {unit}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  </Box>
)}
              {fields.includes('Site Area') && selectedCategory === 'Land' && (
  <Box key="Land Area" sx={{ mb: 2 }}>
    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
      Land Area
    </Typography>

    <Stack direction="row" spacing={2}>
       <TextField
              fullWidth
              label="Acres"
              variant="outlined"
              value={formData.site_area || ''}
               onChange={(e) => handleFieldChange('Site Area', e.target.value)}
      //         onChange={(e) =>
      //   setFormData(prev => ({
      //     ...prev,
      //     site_area: e.target.value
      //   }))
      // }
        required
      />

      <TextField
        select
        label="Units"
        sx={{ minWidth: 120 }}
        value={formData.units || 'acre'}
        onChange={(e) =>
          setFormData((prev) => ({ ...prev, units: e.target.value }))
        }
      >
        {['acre', 'gunta', 'sq.ft', 'sq.m'].map((unit) => (
          <MenuItem key={unit} value={unit}>
            {unit}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  </Box>
)}

              {fields.map((label) => {
                if (label == 'Site Area') return null;

                if (label === 'Buildup Area') {
                  return (
                    <TextField
                      key={label}
                      fullWidth
                      label={getBuildupAreaLabel()}
                      variant="outlined"
                      sx={{ mb: 2 }}
                      value={formValues[label] || ''}
                      onChange={(e) => handleFieldChange(label, e.target.value)}
                      type="number"
                      inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        min: 0
                      }}
                    />
                  );
                }

                if (label == 'Facing') {
                  return (
                    <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                      <InputLabel id={`${label}-label`}>{label}</InputLabel>
                      <Select
                        labelId={`${label}-label`}
                        value={formValues[label] || ''}
                        label={label}
                        onChange={(e) => handleFieldChange(label, e.target.value)}
                        required
                      >
                        {facingOptions.map(option => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                }

                if (label == 'Borewell' || label == 'Lift') {
                  return (
                    <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                      <InputLabel id={`${label}-label`}>{label}</InputLabel>
                      <Select
                        labelId={`${label}-label`}
                        value={formValues[label] || ''}
                        label={label}
                        onChange={(e) => handleFieldChange(label, e.target.value)}
                      >
                        {yesNoOptions.map(option => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                }

                if (label == 'No.of Cars Parking' || label == 'No.of Floors' || label == 'Floors' || label == 'No.of Bedrooms' || label == 'Rooms Count' || label == 'Shop Count' || label == 'House Count' || label == 'Duplex Bedrooms' || label == '1bhk Count' || label == '2bhk Count' || label == '3bhk Count' || label == '1bhk' || label == '2bhk' || label == '3bhk' || label == '4bhk Count') {
                  return (
                    <FormControl fullWidth key={label} sx={{ mb: 2 }}>
                      <InputLabel id={`${label}-label`}>{label}</InputLabel>
                      <Select
                        labelId={`${label}-label`}
                        value={formValues[label] || ''}
                        label={label}
                        onChange={(e) => handleFieldChange(label, e.target.value)}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Limits dropdown height and adds scroll
                            },
                          },
                        }}
                      >
                        {generateNumberOptions().map(number => (
                          <MenuItem key={number} value={number}>{number}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                }

                return (
                  <TextField
                    key={label}
                    fullWidth
                    label={label}
                    variant="outlined"
                    sx={{ mb: 2 }}
                    value={formValues[label] || ''}
                    onChange={(e) => handleFieldChange(label, e.target.value)}
                    required
                    type={isNumericField(label) ? 'number' : 'text'}
                    inputProps={isNumericField(label) ? {
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      min: 0
                    } : {}}
                  />
                );
              })}



              {/* Location Section */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Location
                </Typography>

                {isLoaded && (
                  <Autocomplete
                    onLoad={(autocomplete) => {
                      autocompleteRef.current = autocomplete;
                    }}
                    onPlaceChanged={onPlaceChanged}
                  >
                    <TextField
                      fullWidth
                      label="Search Location"
                      variant="outlined"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                      onBlur={geocodeAddress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={getCurrentLocation} edge="end">
                              <MyLocationIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Autocomplete>
                )}

                {/* Map with marker */}
                {/* <div style={containerStyle}>
                  <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    center={location}
                    zoom={15}
                    onClick={handleMapClick}
                  >
                    {markerIcon && (
                      <Marker
                        position={location}
                        icon={markerIcon}
                      />
                    )}
                  </GoogleMap>
                </div> */}

                {/* <div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    onClick={handleMapClick}
    onDragEnd={(map) => {
      if (map) {
        const center = map.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        setLocation({ lat, lng });

        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
              setAddress(results[0].formatted_address);
            } else {
              setAddress(`Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`);
            }
          });
        }
      }
    }}
  />


  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>
</div> */}

<div style={{ ...containerStyle, position: 'relative' }}>
  <GoogleMap
    mapContainerStyle={{ width: '100%', height: '100%' }}
    center={location}
    zoom={15}
    options={{ gestureHandling: 'greedy' }}
    onLoad={(map) => {
      mapRef.current = map;
    }}
    onDragStart={() => {
      // User started moving the map → unconfirm location, turn button red
      setLocationConfirmed(false);
    }}
  />

  {/* Fixed pin at center */}
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -100%)',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
      <path
        fill="#ff0000"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      />
    </svg>
  </div>

  {/* Confirm location button — red = unconfirmed, green = confirmed */}
  <button
    type="button"
    onClick={() => {
      if (window.google && window.google.maps && mapRef.current) {
        const center = mapRef.current.getCenter();
        const lat = center.lat();
        const lng = center.lng();
         setLocation({ lat, lng });

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat, lng } },
          (results, status) => {
            if (status === 'OK' && results[0]) {
              const selectedAddress = results[0].formatted_address;
              setAddress(selectedAddress);
              setFormData(prev => ({
                ...prev,
                location: selectedAddress,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            } else {
              const fallback = `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
              setAddress(fallback);
              setFormData(prev => ({
                ...prev,
                location: fallback,
                lat: lat.toString(),
                long: lng.toString(),
              }));
            }
            // ✅ Mark location as confirmed → button turns green
            setLocationConfirmed(true);
          }
        );
      }
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: locationConfirmed ? 'green' : 'red', // 🔴 red → 🟢 green
      border: 'none',
      borderRadius: '50%',
      width: '44px',
      height: '44px',
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
      position: 'absolute',
      right: '10px',
      top: '45%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      transition: 'background-color 0.3s ease', // smooth color change
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
      <path fill="white" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
    </svg>
  </button>
</div>

              </Box>

              {/* API Hit Counter (for debugging) */}
              {/* <Typography variant="caption" sx={{ display: 'block', textAlign: 'right', mt: 1 }}>
                            Google Maps API hits: {apiHitCount}
                        </Typography> */}

              {/* Image Upload */}
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>Uploaded Images</Typography>
              <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />} fullWidth sx={{ mb: 3 }}>
                Upload Images
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleWorkPhotosChange}
                  required
                />
              </Button>
                                                   <Typography variant="caption" color="text.secondary">
                Max 4 images allowed
              </Typography>
              {workPhotos.length > 0 && (
                <Typography variant="caption" display="block" gutterBottom>
                  Selected: {workPhotos.length} file(s)
                </Typography>
              )}

             <FormControl fullWidth margin="normal">
  <InputLabel id="posted-by-label">Posted By</InputLabel>
  <Select
    labelId="posted-by-label"
    value={postedBy}
    name="posted_by"
    onChange={handleChange}
    required
  >
    {postedByOptions.map((role) => (
      <MenuItem key={role} value={role}>
        {role}
      </MenuItem>
    ))}
  </Select>
</FormControl>


              {/* Description */}
              {/* <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>Description</Typography>
              <TextField
                fullWidth

                variant="outlined"
                multiline
                rows={4}
                name="description"  // Make sure name matches the key in the state
                value={formValues.description || ''}  // Bind to formValues for real-time input update
                onChange={handleChange}  // Handle changes with handleChange
                sx={{ mb: 2 }}  // Optional styling for spacing
              /> */}

             <>
  {/* 🔥 Full Screen Loader */}
  <FullScreenLoader
    open={loading}
    text="Submitting property..."
  />

  {/* Buttons */}
  <Stack
    direction="row"
    spacing={2}
    justifyContent="center"
    sx={{ mt: 2, mb: 2 }}
  >
    <RedButton
      variant="contained"
      size="large"
      sx={{ px: 4, fontWeight: "bold" }}
      onClick={() => navigate(-1)}
      disabled={loading}
    >
      Cancel
    </RedButton>

    <GreenButton
      variant="contained"
      size="large"
      type="submit"
      disabled={
        loading ||
        !postedBy ||
        (uploadStatus && !uploadStatus.canUpload)
      }
      sx={{
        px: 4,
        fontWeight: "bold",
        opacity: loading ? 0.7 : 1,
        cursor: loading ? "not-allowed" : "pointer",
      }}
    >
      {uploadStatus && !uploadStatus.canUpload
        ? "Upload Limit Reached"
        : "Submit"}
    </GreenButton>
  </Stack>
</>
            </Paper>
            <Box sx={{ height: '70px' }} />
          </Box>
        </Box>
           <SubscriptionModal
  open={subscriptionModal.open}
  type={subscriptionModal.type}
  onClose={() =>
    setSubscriptionModal({ open: false, type: null })
  }
/>

 <GuestLoginModal
              open={showGuestModal}
              onClose={() => {
                setShowGuestModal(false);
              }}
            />
            {showSuccess && (
              <SuccessAlert
                message={alertMessage}
                onClose={() => {
                  setShowSuccess(false);
                  navigate("/dashboard");
                }}
              />
            )}
            
            {showFailure && (
              <FailureAlert
                message={alertMessage}
                onClose={() => {
                  console.log("Closing failure alert"); // Debug log
                  setShowFailure(false);
                  setAlertMessage(""); 
                 
                  navigate("/sellyourproperty-form");
                }}
              />
            )}
      <FormsBottomNavbar />
    </>
  );
};

export default SellYourProperty;